import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    CardTitle,
    Container,
    Form,
    NavItem,
    NavLink,
    Progress,
    Row,
    TabContent,
    TabPane,
    Label
} from "reactstrap"
import { AvField, AvForm, AvGroup } from "availity-reactstrap-validation"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import Dropzone from "react-dropzone"
import { connect } from "react-redux"

import PropsTypes from "prop-types"
import { reportUpload, reportValidate } from "store/actions"
import ReportResult from "./ReportResult"
import { isEmpty, isEqual } from "lodash"
import reportImage from "../../assets/images/Report/csv.png"
import { RESULT_OK, RESULT_ERROR } from "store/baseActionTypes"
import { REPORT_UPLOAD_FAIL, REPORT_UPLOAD_SUCCESS, REPORT_VALIDATE_FAIL, REPORT_VALIDATE_SUCCESS } from "store/tasks/actionTypes"


class ReportUploadThree extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: 1,
            progressValue: 33.5,
            selectedFiles: [],
            validate: {},
            report: {},
            actionResult: {},
            actionResultChanged: false,
            error: {},
            reportType:'',
        }
        this.toggleTab.bind(this)
        this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this)
        this.handleUpload = this.handleUpload.bind(this)
        this.handleValidate = this.handleValidate.bind(this)
        this.goBack = this.goBack.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        const { report, validate, actionResult } = this.props
        if (
            !isEmpty(actionResult) &&
            !isEqual(prevProps.actionResult, actionResult)
        ) {
            console.log("componentDidUpdate->actionResult changed")
            this.setState({ actionResult, actionResultChanged: true })
            if (actionResult.action === REPORT_VALIDATE_SUCCESS) {
                this.toggleTab(2)
            } else if (actionResult.action === REPORT_UPLOAD_SUCCESS) {
                this.toggleTab(3)
            }
        }

        if (!isEmpty(validate) && !isEqual(prevProps.validate, validate)) {
            console.log("componentDidUpdate->validate changed")
            this.setState({ validate })
            // this.toggleTab(2)
        }

        if (!isEmpty(report) && !isEqual(prevProps.report, report)) {
            console.log("componentDidUpdate->report changed")
            this.setState({ report })
            // this.toggleTab(3)
        }
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            if (tab >= 1 && tab <= 3) {
                this.setState({
                    activeTab: tab,
                })
                if (tab === 1) {
                    this.setState({ progressValue: 33.5 })
                }
                if (tab === 2) {
                    this.setState({ progressValue: 67 })
                }
                if (tab === 3) {
                    this.setState({ progressValue: 100 })
                }
            }
        }
    }

    handleUpload() {
        const { onReportUpload } = this.props
        console.log("this.state.validate.batchUpdateId :::: ")
        console.log(this.state.validate.batchId)
        onReportUpload(this.state.validate.batchId)
    }

    goBack() {
        window.location.reload();
    }

    handleValidate(e) {
        e.preventDefault()
        const { onReportValidate } = this.props
        let report = this.state.selectedFiles[0]
        console.log("report.name")
        if (isEmpty(report)) {
            this.setState({ error: "Please upload a valid file" })
            return
        } else if (!report.name.endsWith(".csv")) {
            this.setState({ error: "Please upload only .csv extension file" })
            return
        }
        const formData = new FormData()
        formData.append("report", report)
        formData.append("reportType", this.state.reportType)

        console.log("report ------------- report type:::" + this.state.reportType)
        console.log("formData=" + formData)
        onReportValidate(formData)
    }

    handleAcceptedFiles = files => {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: this.formatBytes(file.size),
            })
        )

        this.setState({ selectedFiles: files })
    }

    /**
     * Formats the size
     */
    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    renderValidateError = () => {
        const { error, actionResult, actionResultChanged } = this.state
        if (!isEmpty(error)) {
            return (
                <Row>
                    <Col>
                        <h5 className="text-danger text-center">
                            {error}
                        </h5>
                    </Col>
                </Row>
            )
        } else if (actionResultChanged === true && !isEmpty(actionResult)) {
            console.log("renderActionResultDlg->actionResultChanged")
            if (actionResult.action === REPORT_VALIDATE_FAIL && actionResult.result === RESULT_ERROR) {
                return (
                    <Row>
                        <Col>
                            <h5 className="text-danger text-center">{actionResult.error}</h5>
                        </Col>
                    </Row>
                )
            } else {
                return null
            }
        } else {
            return null
        }
    }

    renderUploadError = () => {
        const { error, actionResult, actionResultChanged } = this.state
        if (actionResultChanged === true && !isEmpty(actionResult)) {
            console.log("renderActionResultDlg->actionResultChanged")
            if (actionResult.action === REPORT_UPLOAD_FAIL && actionResult.result === RESULT_ERROR) {
                return (
                    <Row>
                        <Col>
                            <h5 className="text-danger text-center">{actionResult.error}</h5>
                        </Col>
                    </Row>
                )
            } else {
                return null
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Report Upload | Kattami</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs
                            breadcrumbItem="Report Upload"
                        />

                        <Card>
                            <CardBody>
                                <div className="wizard clearfix">
                                    <div className="steps clearfix">
                                        <ul>
                                            <NavItem
                                                className={classnames({
                                                    current: this.state.activeTab === 1,
                                                })}
                                            >
                                                <NavLink
                                                    className={classnames({
                                                        active: this.state.activeTab === 1,
                                                    })}
                                                >
                                                    <span className="number">1.</span> Report Upload
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                className={classnames({
                                                    current: this.state.activeTab === 2,
                                                })}
                                            >
                                                <NavLink
                                                    className={classnames({
                                                        active: this.state.activeTab === 2,
                                                    })}
                                                >
                                                    <span className="number">2.</span>{" "}
                                                    <span>Report Upload Validation</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                className={classnames({
                                                    current: this.state.activeTab === 3,
                                                })}
                                            >
                                                <NavLink
                                                    className={
                                                        (classnames({
                                                            active: this.state.activeTab === 3,
                                                        }),
                                                            "done")
                                                    }
                                                >
                                                    <span className="number">3.</span> Report Upload
                                                    Confirmation
                                                </NavLink>
                                            </NavItem>
                                        </ul>
                                    </div>
                                    <div id="bar" className="mt-4">
                                        <Progress
                                            color="success"
                                            striped
                                            animated
                                            value={this.state.progressValue}
                                        />
                                        <div className="progress-bar bg-success progress-bar-striped progress-bar-animated" />
                                    </div>
                                    <div className="content clearfix">
                                        <TabContent
                                            activeTab={this.state.activeTab}
                                            className="body"
                                        >
                                            <TabPane tabId={1}>
                                                <CardTitle className="h4">Report Upload</CardTitle>
                                                <Form className="my-dropzone-height">
                                                    <div>
                                                        <label> Select Report Type :
                                                        <select name="reportType" onChange={(evt) => this.setState({ reportType: evt.target.value })}>
                                                            <option disabled value="">Select Report Type</option>
                                                            <option  value="Child">Child</option>
                                                            <option  value="Adult">Adult</option>
                                                            <option  value="Student">Student</option>
                                                        </select>
                                                        </label>
                                                    </div>

                                                <p className="card-title-desc">
                                                    {" "}
                                                    Drop .csv file with planet position report.
                                                </p>
                                                {this.renderValidateError()}
                                               
                                                    <Dropzone
                                                        onDrop={acceptedFiles =>
                                                            this.handleAcceptedFiles(acceptedFiles)
                                                        }
                                                        multiple={false}
                                                        style={{ "width": "50%", "height": "50%", "border": "1px solid black" }}
                                                    >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div className="dropzone">
                                                                <div
                                                                    className="dz-message needsclick"
                                                                    {...getRootProps()}
                                                                >
                                                                    <input {...getInputProps()} />
                                                                    <div className="mb-3">
                                                                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                    </div>
                                                                    <h4>
                                                                        Drop .csv file here or click to upload.
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                    <div
                                                        className="dropzone-previews mt-3"
                                                        id="file-previews"
                                                    >
                                                        {this.state.selectedFiles.map((f, i) => {
                                                            return (
                                                                <Card
                                                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                    key={i + "-file"}
                                                                >
                                                                    <div className="p-2">
                                                                        <Row className="align-items-center">
                                                                            <Col className="col-auto">
                                                                                <img
                                                                                    data-dz-thumbnail=""
                                                                                    height="80"
                                                                                    className="avatar-sm rounded bg-light"
                                                                                    alt={f.name}
                                                                                    src={reportImage}
                                                                                />
                                                                            </Col>
                                                                            <Col>
                                                                                <Link
                                                                                    to="#"
                                                                                    className="text-muted font-weight-bold"
                                                                                >
                                                                                    {f.name}
                                                                                </Link>
                                                                                <p className="mb-0">
                                                                                    <strong>{f.formattedSize}</strong>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Card>
                                                            )
                                                        })}
                                                    </div>
                                                </Form>

                                                <div className="text-end mt-4">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success waves-effect waves-light"
                                                        onClick={this.handleValidate}
                                                    >
                                                        Validate
                                                    </button>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId={2}>
                                                <ReportResult
                                                    handleUpload={this.handleUpload}
                                                    goBack={this.goBack}
                                                    validate={this.state.validate}
                                                />
                                            </TabPane>
                                            <TabPane tabId={3}>
                                                <div className="row justify-content-center">
                                                    <Col lg="6">
                                                        <div className="text-center">
                                                            {this.state.report && this.state.report ? (
                                                                <div className="text-center">
                                                                    <div className="mb-4">
                                                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                                        <h5 className="text-success">Report uploaded successfully</h5>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <div className="text-center">
                                                                        <div className="mb-4">
                                                                            <i className="mdi mdi-close-circle-outline text-danger display-4" />
                                                                            <h5 className="text-danger">Report upload failed</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="text-end mt-4">

                                                                        <button className="btn btn-danger" onClick={this.goBack}>
                                                                            Go back
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

ReportUploadThree.PropsTypes = {
    onReportValidate: PropsTypes.func,
    onReportUpload: PropsTypes.func,
}

const mapStateToProps = ({ tasks }) => ({
    validate: tasks.validate,
    report: tasks.report,
    actionResult: tasks.actionResult,
})

const mapDispatchToProps = dispatch => ({
    onReportValidate: report => dispatch(reportValidate(report)),
    onReportUpload: (batchId) => dispatch(reportUpload(batchId))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportUploadThree)
